<template>
  <div class="palette-item">
    <div class="palette-item-heading">{{ config.label }}</div>
    <div class="palette-item-body">
      <div v-if="config.texture_url" class="palette-item-texture" @mousedown="mousedown" @touchstart="touchstart" :style="{ backgroundImage: `url(${config.texture_url})` }"></div>
      <div v-else class="palette-item-image" @mousedown="mousedown" @touchstart="touchstart"><div class="palette-item-image-wrapper"><img :src="useSvg() ? config.svg_url : config.img_url"></div></div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import helpers from '../../helpers'
import { app, grid } from '../../display'

export default {
  mixins: [helpers],
  props: ['config'],
  methods: {
    ...mapActions('editor', [
      'inspect',
    ]),
    ...mapActions('item', [
      'setGrabbingConfig',
      'unsetGrabbingConfig',
    ]),
    ...mapActions('madori', [
      'addItem',
    ]),
    mousedown(e) {
      this.setGrabbingConfig(this.config)
      this.inspect({ config: this.config })
      window.addEventListener('mouseup', this.mouseup)
    },
    mouseup(e) {
      this.unsetGrabbingConfig()
      window.removeEventListener('mouseup', this.mouseup)
    },
    touchstart(e) {
      this.inspect({ config: this.config })
      window.addEventListener('touchend', this.touchend)
    },
    touchend(e) {
      this.addItem({ config: this.config })
        .then(instance => {
          let div = 1 / grid.division
          instance.coordinate.set(
            Math.round(grid.size / div) * div,
            Math.round(grid.size / div) * div
          )
        })
      window.removeEventListener('touchend', this.touchend)
    },
  },
}
</script>

<style lang="scss" scoped>
.palette-item {
  flex: 0 0 14.285714286%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  color: #fff;
  font-size: 10px;
}
.palette-item-heading {
  flex: 0 0 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  white-space: pre;
  text-align: center;
  line-height: 1.35;
}
.palette-item-body {
  flex: 1 1 auto;
  max-width: 100%;
}
.palette-item-texture {
  width: 42px;
  height: 42px;
  border: 1px solid #666;
  background-size: 10px 10px;
}
.palette-item-image {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50px;
}
.palette-item-image-wrapper {
  flex: 0 0 auto;
  img {
    pointer-events: none;
    max-width: 120px;
    max-height: 50px;
    width: auto;
    height: auto;
  }
}
</style>


// WEBPACK FOOTER //
// assets/js/components/palette/PaletteItem.vue